module.exports = __webpack_public_path__ + "static/media/ic_term_insurance.9cec213d.svg";